import { InvitationPasswordActionType } from './actions';
import { ErrorInfo } from '../../utils/error-codes';

export interface InvitationPasswordState {
  loading: boolean;
  error: boolean;
  errorInfo?: ErrorInfo;
  success: boolean;
}

const initialState: InvitationPasswordState = {
  loading: false,
  error: false,
  errorInfo: undefined,
  success: false,
};

export default function invitationPasswordReducer(state = initialState, action: any): InvitationPasswordState {
  switch (action.type) {
    case InvitationPasswordActionType.CONFIRM_INVITATION_PASSWORD:
      return { ...state, loading: true, error: false, errorInfo: undefined, success: false };
    case InvitationPasswordActionType.CONFIRM_INVITATION_PASSWORD_SUCCESS:
      return { ...state, loading: false, success: true };
    case InvitationPasswordActionType.CONFIRM_INVITATION_PASSWORD_ERROR:
      return { ...state, loading: false, error: true, errorInfo: action.error };
    default:
      return state;
  }
}
